module.exports = __webpack_public_path__ + "static/media/carousel1.15ae4f14.jpeg";